import { LoopRouteStepParams, OrcaRouteParams } from "@bridgesplit/abf-sdk";

function isWhirlpoolRouteParams(routeParams: LoopRouteStepParams | null | undefined): routeParams is OrcaRouteParams {
    return routeParams != null && routeParams.type === "orca";
}

export { isWhirlpoolRouteParams };
